import styled from "styled-components";
import media from "styled-media-query";

export const DiscordCard = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  padding: 45px;
  border-radius: 10px;
  background: #7289da;

  svg {
    color: #fff;
    font-size: 72px;
    margin-right: 45px;
  }

  div {
    h3 {
      color: #fff;
      font-weight: 800;
      margin: 0;
    }

    p {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.7);
    }

    button {
      background: #2c2f33;
      color: #fff;
      padding: 10px;
      border-radius: 5px;
    }
  }
`;

export const Container = styled.div`
  width: 100%;
  padding: 6rem 2rem;
  background: linear-gradient(to bottom, #f8fafc, #ffffff);
`;

export const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  
  .subtitle {
    text-align: center;
    font-size: 1.1rem;
    color: #4B5563;
    max-width: 700px;
    margin: 0 auto 3rem;
    line-height: 1.7;
  }
`;

export const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  color: #17253D;
  text-align: center;
  margin-bottom: 1rem;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: linear-gradient(90deg, #3454D1, #0891b2);
    border-radius: 2px;
  }
`;

export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin: 4rem 0;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ContactCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
`;

export const CardIcon = styled.div`
  width: 100%;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  color: #ffffff;
  
  &.discord {
    background: linear-gradient(135deg, #7289DA, #5865F2);
  }
  
  &.email {
    background: linear-gradient(135deg, #3454D1, #0891b2);
  }
  
  &.support {
    background: linear-gradient(135deg, #10B981, #059669);
  }
`;

export const CardContent = styled.div`
  padding: 2rem;
  
  h3 {
    font-size: 1.5rem;
    font-weight: 600;
    color: #17253D;
    margin-bottom: 1rem;
  }
  
  p {
    color: #4B5563;
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 1.5rem;
    min-height: 80px;
  }
  
  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    font-weight: 600;
    font-size: 1rem;
    text-decoration: none;
    transition: all 0.3s ease;
    width: 100%;
    
    &.primary-btn {
      background: linear-gradient(90deg, #3454D1, #0891b2);
      color: white;
      
      &:hover {
        background: linear-gradient(90deg, #294bc7, #077991);
      }
    }
    
    &.secondary-btn {
      background: #ffffff;
      color: #3454D1;
      border: 2px solid #3454D1;
      
      &:hover {
        background: rgba(52, 84, 209, 0.1);
      }
    }
  }
`;

export const SocialLinks = styled.div`
  text-align: center;
  margin-top: 5rem;
  
  h3 {
    font-size: 1.5rem;
    font-weight: 600;
    color: #17253D;
    margin-bottom: 1.5rem;
  }
  
  .links {
    display: flex;
    justify-content: center;
    gap: 1.5rem;
    
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background: #ffffff;
      color: #3454D1;
      font-size: 1.5rem;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
      }
    }
  }
`;
